import apiProvider from './utilities/provider'

const url = 'secure-links'

const apiSecureLinks = {
  getSingle: (apiKey) => apiProvider.getSingle(url, apiKey),
}

export default apiSecureLinks
